import { useMemo } from 'react';
import { useRasContext } from './useRasContext';

export function useData<T extends RasContext = RasContext>() {
  const rasContext = useRasContext<T>();

  const data = useMemo(() => rasContext.data || {}, [rasContext.data]);

  return data;
}
